import React from "react";
import "../App.css";
import AdminBoard from "../Components/AdminBoard";

export default function Carte() {
  window.scrollTo(0, 0);
  return (
    <div>
      <AdminBoard />
    </div>
  );
}
